import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons, positions } from '../icons';
import Translate from '../layout/Translate';

export default class ContactsMarker extends Component {

    componentDidMount() {

        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }

    selectTour() {
        this.props.actions.selectMapTour({});
    }

    render () {

        return (
        <div className="map__info" style={{position: 'absolute'
                         }}>
            <div className="map__contact">

                    <div className="map__contact_info">
                        {this.props.content}
                    </div>
            </div>

        </div>







        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/map/ContactsMarker.js